import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { useAuth } from '@modules/auth/hooks';
import { getUserSettings } from '@modules/core/services';

import { CORE_GET_USER_SETTINGS_KEY } from '../constants';
import { UseQueryUserSettingsParams, UserSettings } from '../types';

const useQueryUserSettings = <TError = unknown>(
  params: UseQueryUserSettingsParams,
  options?: Omit<
    UseQueryOptions<UserSettings | undefined, TError, UserSettings | undefined, string[]>,
    'initialData' | 'queryFn' | 'queryKey' | 'onError' | 'onSuccess'
  >,
): UseQueryResult<UserSettings | undefined> => {
  const { isAuthenticated } = useAuth();

  const onSuccessFn = (data: UserSettings | undefined): void => {
    params.onSuccess?.(data);
  };
  const onErrorFn = (err: TError): void => {
    params.onError?.(err);
  };

  const enabledOption = options?.enabled !== undefined ? !!options?.enabled : true;

  return useQuery([CORE_GET_USER_SETTINGS_KEY, params.userId], async () => await getUserSettings(params.userId), {
    ...options,
    onError: onErrorFn,
    onSuccess: onSuccessFn,
    enabled: isAuthenticated === true && enabledOption,
    retry: false,
  });
};

export default useQueryUserSettings;
